export interface DateTimeFormatter {
    formatTime: (time: number | Date | null | undefined, type: 'hms' | 'hm') => string;
    formatDate: (time: number | null | undefined) => string;
    formatDateTime: (time: number | Date | null | undefined) => string;
    formatDuration: (time: number | null | undefined) => string;
}

let dateTimeFormatter: DateTimeFormatter = {
    formatTime: function (time: number | Date | null | undefined, type: 'hms' | 'hm'): string {
        throw new Error('Function not implemented.');
    },
    formatDate: function (time: number | null | undefined): string {
        throw new Error('Function not implemented.');
    },
    formatDateTime: function (time: number | Date | null | undefined): string {
        throw new Error('Function not implemented.');
    },
    formatDuration: function (time: number | null | undefined): string {
        throw new Error('Function not implemented.');
    }
};

export function setDateTimeFormatter(newFormatter: DateTimeFormatter) {
    dateTimeFormatter = newFormatter;
}

export function getDateTimeFormatter() {
    return dateTimeFormatter;
}
